






















export default {
	name: 'TextAreaInput',

	props: {
		label: {
			required: false,
			type: String,
		},
		value: {
			required: false,
			type: String,
		},
		placeholder: {
			required: false,
			type: String,
		},
		error: {
			default: '',
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
	},

	methods: {
		updateValue(value: string) {
			this.$emit('input', value);
		},
	},
};
